import { BatchDto } from "@juicy/models/dto";
import { BatchCommentDto } from "@juicy/models/src/dto/AddBatchDto";
import { Button, Card, Icon, Input, Text } from "@ui-kitten/components";
import moment from "moment";
import React, { useState } from "react";
import { View } from "react-native";
import { apiService } from "../../App";
import { Rating } from "../recipe/rating";

interface AddCommentProps {
    batch: BatchDto;
    onCommentAdded?: (comment: BatchCommentDto) => void;
    onCommentEdited?: (comment: BatchCommentDto) => void;
    onCommentDeleted?: (result: boolean) => void;
    onCloseForm?: () => void;
    commentToEdit?: BatchCommentDto;
}

export const AddCommentForm: React.FC<AddCommentProps> = ({
    batch,
    commentToEdit,
    onCommentAdded,
    onCommentEdited,
    onCommentDeleted,
    onCloseForm,
}) => {
    const [nDaysAfter, setNDaysAfter] = useState<string>(
        commentToEdit
            ? commentToEdit.nDaysAfter.toString()
            : Math.ceil(moment().diff(batch.createdAt, "days", true)).toString()
    );
    const [comment, setComment] = useState(commentToEdit ? commentToEdit.comment : "");
    const [rating, setRating] = useState<number | undefined>(commentToEdit ? commentToEdit.rating : undefined);

    const handleSave = async () => {
        let batchComment;
        const data = {
            comment,
            nDaysAfter: parseInt(nDaysAfter),
            rating,
        };
        if (commentToEdit) {
            batchComment = await apiService.batch.editComment({
                ...commentToEdit,
                ...data,
            });
            if (onCommentEdited) {
                onCommentEdited(batchComment);
            }
        } else {
            batchComment = await apiService.batch.addComment(batch, data);
            if (onCommentAdded) {
                onCommentAdded(batchComment);
            }
        }
    };
    const handleDelete = async () => {
        if (commentToEdit) {
            const result = await apiService.batch.deleteComment(commentToEdit);
            if (onCommentDeleted) {
                onCommentDeleted(result);
            }
        }
    };

    return (
        <View style={{ marginTop: 10 }}>
            {commentToEdit === undefined && (
                <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <Text appearance="hint">Add a comment</Text>
                    <Button
                        onPress={() => onCloseForm && onCloseForm()}
                        accessoryLeft={(props) => <Icon {...props} name="close-square-outline" />}
                        size={"medium"}
                        appearance="ghost"
                        style={{ marginTop: 2, padding: 0 }}
                    />
                </View>
            )}
            <Card>
                <Text category="s1">How many days has the liquid steeped?</Text>
                <Input
                    value={nDaysAfter}
                    onChangeText={setNDaysAfter}
                    placeholder="number of days"
                    style={{ marginBottom: 15 }}
                />
                {/* <Text category="s1">Rating</Text> */}
                {/* <Rating rating={rating} onChange={setRating} size="large" autoExpand={false} /> */}
                <Text style={{ marginTop: 15 }} category="s1">
                    Comment
                </Text>
                <Input
                    value={comment}
                    onChangeText={setComment}
                    multiline={true}
                    textStyle={{ minHeight: 80 }}
                    placeholder="Comment"
                    style={{ marginBottom: 20 }}
                />
                <Button size="small" onPress={() => handleSave()}>
                    {commentToEdit !== undefined ? `Edit comment` : `Add a comment`}
                </Button>
                {commentToEdit !== undefined && (
                    <Button style={{ marginTop: 20 }} status="danger" size="small" onPress={() => handleDelete()}>
                        Delete Comment
                    </Button>
                )}
            </Card>
        </View>
    );
};
